export default {
    inclinic: 'in-clinic',
    remote: 'remote',
  };